<template>
  <with-file-create-update-form 
    ref="form" :model="model" v-bind="$attrs" :placeholder="placeholder"  
    :form-title="formTitle" :is-update-mode="isUpdateMode" @update="save" @create="save"
  />
</template>

<script>
import { mapActions } from "vuex";
import WithFileCreateUpdateForm from '@/components/Form/WithFileCreateUpdateForm.vue'

export default {
   components: { WithFileCreateUpdateForm },
  data() {
    return {
      placeholder: {
        name: this.$t('model_output.page.placeholder.name'),
        description: this.$t('model_output.page.placeholder.desc'),
      },
      isUpdateMode: false,
      model: {},
    };
  },
  computed: {
    changesMade() {
      return JSON.stringify(this.model) !== JSON.stringify(this.$route.params.model);
    },
    actionButtonTitle() {
      return this.isUpdateMode ? this.$t('generic.button.update') : this.$t('generic.button.upload'); 
    },
    formTitle() {
      return this.isUpdateMode ? this.$t("model_output.page.update_form_title") : this.$t("model_output.page.create_form_title"); 
    },
  },
  async created() {
    this.isUpdateMode = this.$route.params.action === 'EDIT'
    this.model = { ...this.$route.params.model, file: [] };
  },
  mounted(){
    this.$refs.form.updateModel(this.model)
  },
  methods: {
    ...mapActions(["uploadDocumentFile", "updateModel"]),
    endSaveUpdateAction() {
      // We wait 2 seconds to route to details so see the new file from autodesk (TODO check this with big files)
      setTimeout(() => {
        this.$router.push({
        name: "detail",
        params: { id: this.$route.params.id },
      })} 
      , 2000);
    },
    async save() {
      const actionPerformed = 'generic.action_performed.'.concat(this.isUpdateMode ? 'updated' : 'created')

      const successMsg = this.$t('generic.message.success', [this.$t('entity.model_outputs'), this.$t(actionPerformed)])
      const errorMsg = this.$t('generic.message.error', [this.$t('entity.model_outputs'), this.$t(actionPerformed)])

      const payload = {
        data: {
          name: this.model.name,
          description: this.model.description,
          version: this.model.version,
          projectId: this.$route.params.id,
        },
        collection: 'model-output',
        file: this.model.file,
      };

      if (this.isUpdateMode) {
        payload.id = this.model.id
        await this.updateModel(payload).then(() => {
            this.showSnackbar(successMsg, this.$t('generic.status.success'));
            this.endSaveUpdateAction();
          }).catch(() => {
            this.showSnackbar(errorMsg, this.$t('generic.status.error'));
          });
      } else {
        payload.data.fileName = this.model.file[0].name
        await this.uploadDocumentFile(payload).then(() => {
            this.showSnackbar(successMsg, this.$t('generic.status.success'));
            this.endSaveUpdateAction();
          }).catch(() => {
            this.showSnackbar(errorMsg, this.$t('generic.status.error'));
          });
      }
    },
  },
};
</script>
